import React, { useMemo } from 'react';
import { useHistory } from "react-router-dom";
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import List from 'devextreme-react/list';
import { useAuth } from 'contexts/auth';
import { useTheme } from 'contexts/theme';
import './user-panel.scss';

export default function UserPanel({ menuMode }) {
  const { user, signOut } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const history = useHistory();

  function navigateToProfile() {
    history.push("/profile");
  }

  function navigateToNotification() {
    history.push("/notification");
  }
  const menuItems = useMemo(() => ([
    {
      text: 'Profile',
      icon: 'user',
      onClick: navigateToProfile
    },
    {
      text: 'Notification',
      icon: 'bell',
      onClick: navigateToNotification
    },
    {
      text: theme === 'dark' ? 'Light Mode' : 'Dark Mode',
      icon: 'moon',
      onClick: toggleTheme
    },
    {
      text: 'Logout',
      icon: 'runner',
      onClick: signOut
    }
  ]), [signOut, theme, toggleTheme]);

  return (
    <div className={'user-panel'}>
      {menuMode === 'context' && (
        <>
          <div className={'user-info'}>
            <div className={'image-container'}>
              <div className='user-panel-icon'>
                <i className="dx-icon-user dx-icon-custom-style" ></i>
              </div>
            </div>
            <div className={'user-name'}>{user.email}</div>
          </div>
          <ContextMenu
            items={menuItems}
            target={'.user-button'}
            showEvent={'dxclick'}
            width={210}
            cssClass={'user-menu'}
          >
            <Position my={'top center'} at={'bottom center'} />
          </ContextMenu>
        </>
      )}
      {menuMode === 'list' && (
        <>
          <div className={'user-info'}>
            <div className={'image-container'}>
              <div className='user-panel-icon-after'>
                <i className="dx-icon-user dx-icon-custom-style" ></i>
              </div>
            </div>
            <div className={'user-name'}>{user.email}</div>
          </div>
          <List className={'dx-toolbar-menu-action'} items={menuItems} />
        </>
      )}
    </div>
  );
}
